// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_search.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppExpandMask } from "../../app/v1/app";
import { AppView } from "../../app/v1/app";
import { AppUserExpandMask } from "../../app/v1/app_user";
import { TaskView } from "../../task/v1/task";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppUserView } from "../../app/v1/app_user";
import { AppResourceTypeView } from "../../app/v1/app_resource";
import { AppResource } from "../../app/v1/app_resource";
import { UserExpandMask } from "../../user/v1/user";
import { UserView } from "../../user/v1/user";
import { AppUser } from "../../app/v1/app_user";
import { AccessReviewEntitlementRollup } from "./accessreview";
import { AccessReviewEntitlementRollupByApp } from "./accessreview";
import { AccessReviewEntitlementRollupExpandMask } from "./accessreview";
import { Facets } from "../../search/v1/facet";
import { AccessReviewAppEntitlementView } from "./accessreview";
import { AccessReviewAppEntitlementExpandMask } from "./accessreview";
import { AccessReview } from "./accessreview";
import { App } from "../../app/v1/app";
import { User } from "../../user/v1/user";
import { Any } from "../../../../google/protobuf/any";
import { AccessReviewView } from "./accessreview";
import { PolicyRef } from "../../policy/v1/policy";
import { AccessReviewRef } from "./accessreview";
import { SortOptions } from "../../search/v1/sort";
import { AccessReviewExpandMask } from "./accessreview";
import { AccessReviewState } from "./accessreview";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest
 */
export interface AccessReviewSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewState access_review_states = 4
     */
    accessReviewStates: AccessReviewState[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewExpandMask;
    /**
     * @generated from protobuf field: c1.api.search.v1.SortOptions sort_options = 7
     */
    sortOptions?: SortOptions;
    /**
     * @generated from protobuf field: repeated string owner_ids = 8
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: string access_review_template_id = 9
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewRef refs = 10
     */
    refs: AccessReviewRef[];
    /**
     * Search for access reviews that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 11
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse
 */
export interface AccessReviewSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest
 */
export interface AccessReviewSearchServiceSelectionsStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest
 */
export interface AccessReviewSearchServiceCountOpenReviewsByUserRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * If not specified, defaults to returning all reviewers.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewerCompletionFilter reviewer_completion_filter = 4
     */
    reviewerCompletionFilter: ReviewerCompletionFilter;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse
 */
export interface AccessReviewSearchServiceCountOpenReviewsByUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.UserToReviewCount list = 1
     */
    list: UserToReviewCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest
 */
export interface AccessReviewSearchServiceCountCompleteReviewersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse
 */
export interface AccessReviewSearchServiceCountCompleteReviewersResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest
 */
export interface AccessReviewSearchServiceCountIncompleteReviewersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse
 */
export interface AccessReviewSearchServiceCountIncompleteReviewersResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest
 */
export interface AccessReviewSearchServiceGetReviewerDecisionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewerDecisionSort sort = 4
     */
    sort: ReviewerDecisionSort;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse
 */
export interface AccessReviewSearchServiceGetReviewerDecisionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ReviewerDecision list = 1
     */
    list: ReviewerDecision[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ReviewerDecision
 */
export interface ReviewerDecision {
    /**
     * Deprecated: Use user_id instead and fetch user details separately.
     *
     * @deprecated
     * @generated from protobuf field: c1.api.user.v1.User user = 1 [deprecated = true]
     */
    user?: User;
    /**
     * @generated from protobuf field: int64 approved = 2
     */
    approved: number;
    /**
     * @generated from protobuf field: int64 denied = 3
     */
    denied: number;
    /**
     * @generated from protobuf field: int64 total_assigned = 4
     */
    totalAssigned: number;
    /**
     * @generated from protobuf field: int64 approval_rate = 5
     */
    approvalRate: number;
    /**
     * @generated from protobuf field: string user_id = 6
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UserToReviewCount
 */
export interface UserToReviewCount {
    /**
     * Deprecated: Use user_id instead and fetch user details separately.
     *
     * @deprecated
     * @generated from protobuf field: c1.api.user.v1.User user = 1 [deprecated = true]
     */
    user?: User;
    /**
     * @generated from protobuf field: int64 open_reviews = 2
     */
    openReviews: number;
    /**
     * @generated from protobuf field: int64 total_reviews = 3
     */
    totalReviews: number;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest
 */
export interface AccessReviewSearchServiceGetProgressByAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse
 */
export interface AccessReviewSearchServiceGetProgressByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppProgressCount list = 1
     */
    list: AppProgressCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppProgressCount
 */
export interface AppProgressCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 open_count = 2
     */
    openCount: number;
    /**
     * @generated from protobuf field: int64 closed_count = 3
     */
    closedCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse
 */
export interface AccessReviewSearchServiceSelectionsStatusResponse {
    /**
     * @generated from protobuf field: int32 total = 1
     */
    total: number;
    /**
     * @generated from protobuf field: int32 certified = 2
     */
    certified: number;
    /**
     * @generated from protobuf field: int32 rejected = 3
     */
    rejected: number;
    /**
     * @generated from protobuf field: int32 skipped = 4
     */
    skipped: number;
    /**
     * @generated from protobuf field: int32 cancelled = 5
     */
    cancelled: number;
    /**
     * @generated from protobuf field: int32 deleted = 6
     */
    deleted: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewRollup
 */
export interface AccessReviewRollup {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2
     */
    assignedTasks: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest
 */
export interface AccessReviewSearchServiceRollupRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool exclude_completed = 4
     */
    excludeCompleted: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse
 */
export interface AccessReviewSearchServiceRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewRollup list = 1
     */
    list: AccessReviewRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest
 */
export interface AccessReviewSearchServiceSearchEntitlementsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 7
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 8
     */
    complianceFrameworkIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 9
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: bool exclude_facets = 10
     */
    excludeFacets: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse
 */
export interface AccessReviewSearchServiceSearchEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1
     */
    list: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest
 */
export interface AccessReviewSearchServiceSearchEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 7
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 8
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse
 */
export interface AccessReviewSearchServiceSearchEntitlementsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppRollup
 */
export interface AccessReviewAppRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2
     */
    assignedTasks: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef
 */
export interface AccessReviewSearchServiceEntitlementRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest
 */
export interface AccessReviewSearchServiceEntitlementRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewEntitlementRollupExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6
     */
    refs: AccessReviewSearchServiceEntitlementRollupRef[];
    /**
     * @generated from protobuf field: string query = 7
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse
 */
export interface AccessReviewSearchServiceEntitlementRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp list = 1
     */
    list: AccessReviewEntitlementRollupByApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest
 */
export interface AccessReviewSearchServiceEntitlementRollupByAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewEntitlementRollupExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6
     */
    refs: AccessReviewSearchServiceEntitlementRollupRef[];
    /**
     * @generated from protobuf field: string query = 7
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 8
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse
 */
export interface AccessReviewSearchServiceEntitlementRollupByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 1
     */
    list: AccessReviewEntitlementRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollup
 */
export interface AccessReviewAppUserRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: int32 task_count = 2
     */
    taskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts
 */
export interface AccessReviewAccountsWithNoIdentityTaskCounts {
    /**
     * @generated from protobuf field: int32 open_task_count = 1
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 2
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 3
     */
    pendingActionsCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus
 */
export interface AccessReviewAccountsWithNoIdentityTaskStatus {
    /**
     * @generated from protobuf field: bool has_open_tasks = 1
     */
    hasOpenTasks: boolean;
    /**
     * @generated from protobuf field: bool has_completed_tasks = 2
     */
    hasCompletedTasks: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewUserRollup
 */
export interface AccessReviewUserRollup {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserView user = 1
     */
    user?: UserView;
    /**
     * @generated from protobuf field: int32 open_task_count = 2
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string id = 5
     */
    id: string;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 6
     */
    pendingActionsCount: number;
    /**
     * @generated from protobuf field: int64 pending_submission_count = 7
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef
 */
export interface AccessReviewSearchServiceUserRollupRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest
 */
export interface AccessReviewSearchServiceUserRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef refs = 5
     */
    refs: AccessReviewSearchServiceUserRollupRef[];
    /**
     * @generated from protobuf field: string query = 6
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse
 */
export interface AccessReviewSearchServiceUserRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewUserRollup list = 1
     */
    list: AccessReviewUserRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest
 */
export interface AccountsWithNoIdentityTaskCountsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest
 */
export interface AccountsWithNoIdentityTaskStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest
 */
export interface AccessReviewSearchServiceUserRollupUserNavDataRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string current_user_id = 3
     */
    currentUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse
 */
export interface AccessReviewSearchServiceUserRollupUserNavDataResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup previous_user = 1
     */
    previousUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup current_user = 2
     */
    currentUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup next_user = 3
     */
    nextUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest
 */
export interface AccessReviewSearchServiceSearchAppUsersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse
 */
export interface AccessReviewSearchServiceSearchAppUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUser list = 1
     */
    list: AppUser[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppResourceRollupItem
 */
export interface AccessReviewAppResourceRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource item = 1
     */
    item?: AppResource;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView entitlements = 2
     */
    entitlements: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceRollupRef
 */
export interface ResourceRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 2
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest
 */
export interface AccessReviewSearchServiceSearchSelectedResourceRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string query = 6
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ResourceRollupRef refs = 7
     */
    refs: ResourceRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse
 */
export interface AccessReviewSearchServiceSearchSelectedResourceRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppResourceRollupItem list = 1
     */
    list: AccessReviewAppResourceRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem
 */
export interface AccessReviewAppResourceTypeRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeView item = 1
     */
    item?: AppResourceTypeView;
    /**
     * @generated from protobuf field: int64 resource_count = 2
     */
    resourceCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceTypeRollupRef
 */
export interface ResourceTypeRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest
 */
export interface AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ResourceTypeRollupRef refs = 5
     */
    refs: ResourceTypeRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse
 */
export interface AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem list = 1
     */
    list: AccessReviewAppResourceTypeRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef
 */
export interface AccessReviewAppUserDetailRowSearchRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewUserNavRollupRef
 */
export interface AccessReviewUserNavRollupRef {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppNavRollupRef
 */
export interface AccessReviewAppNavRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest
 */
export interface AccessReviewAppUserDetailRowSearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 6
     */
    expandMask?: AccessReviewAppUserDetailRowExpandMask;
    /**
     * @generated from protobuf field: repeated string app_user_ids = 7
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 8
     */
    refs: AccessReviewAppUserDetailRowSearchRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 9
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse
 */
export interface AccessReviewAppUserDetailRowSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRow list = 1
     */
    list: AccessReviewAppUserDetailRow[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest
 */
export interface AccessReviewAppUserRollupNavDataRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewAppUserDetailRowExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse
 */
export interface AccessReviewAppUserRollupNavDataResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView previous_user = 1
     */
    previousUser?: AppUserView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView current_user = 2
     */
    currentUser?: AppUserView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView next_user = 3
     */
    nextUser?: AppUserView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest
 */
export interface AccessReviewSearchServiceNavFirstOpenSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 3
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse
 */
export interface AccessReviewSearchServiceNavFirstOpenSelectionResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 2
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest
 */
export interface AccessReviewSearchServiceNavNextSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
    /**
     * no validation for current_user_id, as rpc can request next for unassigned
     *
     * @generated from protobuf field: string current_id = 5
     */
    currentId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 4
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse
 */
export interface AccessReviewSearchServiceNavNextSelectionResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 2
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask
 */
export interface AccessReviewAppUserDetailRowExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails
 */
export interface AccessReviewAppUserDetailRowTaskDetails {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 2
     */
    task?: TaskView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRow
 */
export interface AccessReviewAppUserDetailRow {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1
     */
    appUser?: AppUserView;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails entitlements = 2
     */
    entitlements: AccessReviewAppUserDetailRowTaskDetails[];
    /**
     * @generated from protobuf field: bool AllTicketsCompleted = 3
     */
    allTicketsCompleted: boolean;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 6
     */
    pendingActionsCount: number;
    /**
     * @generated from protobuf field: int32 open_task_count = 7
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 8
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppUserRollup
 */
export interface AppUserRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1
     */
    appUser?: AppUserView;
    /**
     * @generated from protobuf field: int32 open_task_count = 3
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 4
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int32 pending_submission_count = 5
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppUserRollupRequest
 */
export interface SearchAppUserRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 6
     */
    expandMask?: AppUserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 7
     */
    refs: AccessReviewAppUserDetailRowSearchRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppUserRollupResponse
 */
export interface SearchAppUserRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserRollup list = 1
     */
    list: AppUserRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppRollup
 */
export interface AppRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppView app = 1
     */
    app?: AppView;
    /**
     * @generated from protobuf field: int32 task_count = 2
     */
    taskCount: number;
    /**
     * @generated from protobuf field: int32 open_task_count = 3
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 4
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int32 pending_submission_count = 5
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppRollupRequest
 */
export interface SearchAppRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 5
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppNavRollupRef refs = 6
     */
    refs: AccessReviewAppNavRollupRef[];
    /**
     * @generated from protobuf field: string query = 7
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppRollupResponse
 */
export interface SearchAppRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppRollup list = 1
     */
    list: AppRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewerCompletionFilter
 */
export enum ReviewerCompletionFilter {
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_COMPLETE = 2;
     */
    COMPLETE = 2,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_INCOMPLETE = 3;
     */
    INCOMPLETE = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewerDecisionSort
 */
export enum ReviewerDecisionSort {
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_APPROVAL_RATE_ASC = 1;
     */
    APPROVAL_RATE_ASC = 1,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_APPROVAL_RATE_DESC = 2;
     */
    APPROVAL_RATE_DESC = 2,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_TOTAL_ASSIGNED_ASC = 3;
     */
    TOTAL_ASSIGNED_ASC = 3,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_TOTAL_ASSIGNED_DESC = 4;
     */
    TOTAL_ASSIGNED_DESC = 4
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.NextOpenSelectionType
 */
export enum NextOpenSelectionType {
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_APP = 1;
     */
    APP = 1,
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_USER = 2;
     */
    USER = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchRequest$Type extends MessageType<AccessReviewSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AccessReviewState", AccessReviewState, "ACCESS_REVIEW_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask },
            { no: 7, name: "sort_options", kind: "message", T: () => SortOptions },
            { no: 8, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewRef },
            { no: 11, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchRequest>): AccessReviewSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.accessReviewStates = [];
        message.ownerIds = [];
        message.accessReviewTemplateId = "";
        message.refs = [];
        message.policyRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchRequest): AccessReviewSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewState access_review_states */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accessReviewStates.push(reader.int32());
                    else
                        message.accessReviewStates.push(reader.int32());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.search.v1.SortOptions sort_options */ 7:
                    message.sortOptions = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sortOptions);
                    break;
                case /* repeated string owner_ids */ 8:
                    message.ownerIds.push(reader.string());
                    break;
                case /* string access_review_template_id */ 9:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewRef refs */ 10:
                    message.refs.push(AccessReviewRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.policy.v1.PolicyRef policy_refs */ 11:
                    message.policyRefs.push(PolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.accessreview.v1.AccessReviewState access_review_states = 4; */
        if (message.accessReviewStates.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accessReviewStates.length; i++)
                writer.int32(message.accessReviewStates[i]);
            writer.join();
        }
        /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.search.v1.SortOptions sort_options = 7; */
        if (message.sortOptions)
            SortOptions.internalBinaryWrite(message.sortOptions, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string owner_ids = 8; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.ownerIds[i]);
        /* string access_review_template_id = 9; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* repeated c1.api.accessreview.v1.AccessReviewRef refs = 10; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewRef.internalBinaryWrite(message.refs[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.policy.v1.PolicyRef policy_refs = 11; */
        for (let i = 0; i < message.policyRefs.length; i++)
            PolicyRef.internalBinaryWrite(message.policyRefs[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest
 */
export const AccessReviewSearchServiceSearchRequest = new AccessReviewSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchResponse$Type extends MessageType<AccessReviewSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchResponse>): AccessReviewSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchResponse): AccessReviewSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewView list */ 1:
                    message.list.push(AccessReviewView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse
 */
export const AccessReviewSearchServiceSearchResponse = new AccessReviewSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSelectionsStatusRequest$Type extends MessageType<AccessReviewSearchServiceSelectionsStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSelectionsStatusRequest>): AccessReviewSearchServiceSelectionsStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSelectionsStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSelectionsStatusRequest): AccessReviewSearchServiceSelectionsStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSelectionsStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest
 */
export const AccessReviewSearchServiceSelectionsStatusRequest = new AccessReviewSearchServiceSelectionsStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountOpenReviewsByUserRequest$Type extends MessageType<AccessReviewSearchServiceCountOpenReviewsByUserRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "reviewer_completion_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewerCompletionFilter", ReviewerCompletionFilter, "REVIEWER_COMPLETION_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountOpenReviewsByUserRequest>): AccessReviewSearchServiceCountOpenReviewsByUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.reviewerCompletionFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountOpenReviewsByUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountOpenReviewsByUserRequest): AccessReviewSearchServiceCountOpenReviewsByUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewerCompletionFilter reviewer_completion_filter */ 4:
                    message.reviewerCompletionFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountOpenReviewsByUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.ReviewerCompletionFilter reviewer_completion_filter = 4; */
        if (message.reviewerCompletionFilter !== 0)
            writer.tag(4, WireType.Varint).int32(message.reviewerCompletionFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest
 */
export const AccessReviewSearchServiceCountOpenReviewsByUserRequest = new AccessReviewSearchServiceCountOpenReviewsByUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountOpenReviewsByUserResponse$Type extends MessageType<AccessReviewSearchServiceCountOpenReviewsByUserResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserToReviewCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountOpenReviewsByUserResponse>): AccessReviewSearchServiceCountOpenReviewsByUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountOpenReviewsByUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountOpenReviewsByUserResponse): AccessReviewSearchServiceCountOpenReviewsByUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.UserToReviewCount list */ 1:
                    message.list.push(UserToReviewCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountOpenReviewsByUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.UserToReviewCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserToReviewCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse
 */
export const AccessReviewSearchServiceCountOpenReviewsByUserResponse = new AccessReviewSearchServiceCountOpenReviewsByUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountCompleteReviewersRequest$Type extends MessageType<AccessReviewSearchServiceCountCompleteReviewersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountCompleteReviewersRequest>): AccessReviewSearchServiceCountCompleteReviewersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountCompleteReviewersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountCompleteReviewersRequest): AccessReviewSearchServiceCountCompleteReviewersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountCompleteReviewersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest
 */
export const AccessReviewSearchServiceCountCompleteReviewersRequest = new AccessReviewSearchServiceCountCompleteReviewersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountCompleteReviewersResponse$Type extends MessageType<AccessReviewSearchServiceCountCompleteReviewersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountCompleteReviewersResponse>): AccessReviewSearchServiceCountCompleteReviewersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountCompleteReviewersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountCompleteReviewersResponse): AccessReviewSearchServiceCountCompleteReviewersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountCompleteReviewersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse
 */
export const AccessReviewSearchServiceCountCompleteReviewersResponse = new AccessReviewSearchServiceCountCompleteReviewersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountIncompleteReviewersRequest$Type extends MessageType<AccessReviewSearchServiceCountIncompleteReviewersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountIncompleteReviewersRequest>): AccessReviewSearchServiceCountIncompleteReviewersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountIncompleteReviewersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountIncompleteReviewersRequest): AccessReviewSearchServiceCountIncompleteReviewersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountIncompleteReviewersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest
 */
export const AccessReviewSearchServiceCountIncompleteReviewersRequest = new AccessReviewSearchServiceCountIncompleteReviewersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountIncompleteReviewersResponse$Type extends MessageType<AccessReviewSearchServiceCountIncompleteReviewersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceCountIncompleteReviewersResponse>): AccessReviewSearchServiceCountIncompleteReviewersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceCountIncompleteReviewersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceCountIncompleteReviewersResponse): AccessReviewSearchServiceCountIncompleteReviewersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceCountIncompleteReviewersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse
 */
export const AccessReviewSearchServiceCountIncompleteReviewersResponse = new AccessReviewSearchServiceCountIncompleteReviewersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetReviewerDecisionsRequest$Type extends MessageType<AccessReviewSearchServiceGetReviewerDecisionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "sort", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewerDecisionSort", ReviewerDecisionSort, "REVIEWER_DECISION_SORT_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceGetReviewerDecisionsRequest>): AccessReviewSearchServiceGetReviewerDecisionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.sort = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceGetReviewerDecisionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceGetReviewerDecisionsRequest): AccessReviewSearchServiceGetReviewerDecisionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewerDecisionSort sort */ 4:
                    message.sort = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceGetReviewerDecisionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.ReviewerDecisionSort sort = 4; */
        if (message.sort !== 0)
            writer.tag(4, WireType.Varint).int32(message.sort);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest
 */
export const AccessReviewSearchServiceGetReviewerDecisionsRequest = new AccessReviewSearchServiceGetReviewerDecisionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetReviewerDecisionsResponse$Type extends MessageType<AccessReviewSearchServiceGetReviewerDecisionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReviewerDecision },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceGetReviewerDecisionsResponse>): AccessReviewSearchServiceGetReviewerDecisionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceGetReviewerDecisionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceGetReviewerDecisionsResponse): AccessReviewSearchServiceGetReviewerDecisionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.ReviewerDecision list */ 1:
                    message.list.push(ReviewerDecision.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceGetReviewerDecisionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.ReviewerDecision list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ReviewerDecision.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse
 */
export const AccessReviewSearchServiceGetReviewerDecisionsResponse = new AccessReviewSearchServiceGetReviewerDecisionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewerDecision$Type extends MessageType<ReviewerDecision> {
    constructor() {
        super("c1.api.accessreview.v1.ReviewerDecision", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "approved", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "denied", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "total_assigned", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "approval_rate", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReviewerDecision>): ReviewerDecision {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.approved = 0;
        message.denied = 0;
        message.totalAssigned = 0;
        message.approvalRate = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<ReviewerDecision>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReviewerDecision): ReviewerDecision {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user = 1 [deprecated = true] */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* int64 approved */ 2:
                    message.approved = reader.int64().toNumber();
                    break;
                case /* int64 denied */ 3:
                    message.denied = reader.int64().toNumber();
                    break;
                case /* int64 total_assigned */ 4:
                    message.totalAssigned = reader.int64().toNumber();
                    break;
                case /* int64 approval_rate */ 5:
                    message.approvalRate = reader.int64().toNumber();
                    break;
                case /* string user_id */ 6:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReviewerDecision, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1 [deprecated = true]; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 approved = 2; */
        if (message.approved !== 0)
            writer.tag(2, WireType.Varint).int64(message.approved);
        /* int64 denied = 3; */
        if (message.denied !== 0)
            writer.tag(3, WireType.Varint).int64(message.denied);
        /* int64 total_assigned = 4; */
        if (message.totalAssigned !== 0)
            writer.tag(4, WireType.Varint).int64(message.totalAssigned);
        /* int64 approval_rate = 5; */
        if (message.approvalRate !== 0)
            writer.tag(5, WireType.Varint).int64(message.approvalRate);
        /* string user_id = 6; */
        if (message.userId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ReviewerDecision
 */
export const ReviewerDecision = new ReviewerDecision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserToReviewCount$Type extends MessageType<UserToReviewCount> {
    constructor() {
        super("c1.api.accessreview.v1.UserToReviewCount", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "open_reviews", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "total_reviews", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserToReviewCount>): UserToReviewCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openReviews = 0;
        message.totalReviews = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<UserToReviewCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserToReviewCount): UserToReviewCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user = 1 [deprecated = true] */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* int64 open_reviews */ 2:
                    message.openReviews = reader.int64().toNumber();
                    break;
                case /* int64 total_reviews */ 3:
                    message.totalReviews = reader.int64().toNumber();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserToReviewCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1 [deprecated = true]; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 open_reviews = 2; */
        if (message.openReviews !== 0)
            writer.tag(2, WireType.Varint).int64(message.openReviews);
        /* int64 total_reviews = 3; */
        if (message.totalReviews !== 0)
            writer.tag(3, WireType.Varint).int64(message.totalReviews);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UserToReviewCount
 */
export const UserToReviewCount = new UserToReviewCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetProgressByAppRequest$Type extends MessageType<AccessReviewSearchServiceGetProgressByAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceGetProgressByAppRequest>): AccessReviewSearchServiceGetProgressByAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceGetProgressByAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceGetProgressByAppRequest): AccessReviewSearchServiceGetProgressByAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceGetProgressByAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest
 */
export const AccessReviewSearchServiceGetProgressByAppRequest = new AccessReviewSearchServiceGetProgressByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetProgressByAppResponse$Type extends MessageType<AccessReviewSearchServiceGetProgressByAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppProgressCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceGetProgressByAppResponse>): AccessReviewSearchServiceGetProgressByAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceGetProgressByAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceGetProgressByAppResponse): AccessReviewSearchServiceGetProgressByAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppProgressCount list */ 1:
                    message.list.push(AppProgressCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceGetProgressByAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppProgressCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppProgressCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse
 */
export const AccessReviewSearchServiceGetProgressByAppResponse = new AccessReviewSearchServiceGetProgressByAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppProgressCount$Type extends MessageType<AppProgressCount> {
    constructor() {
        super("c1.api.accessreview.v1.AppProgressCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "open_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "closed_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppProgressCount>): AppProgressCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openCount = 0;
        message.closedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppProgressCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppProgressCount): AppProgressCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int64 open_count */ 2:
                    message.openCount = reader.int64().toNumber();
                    break;
                case /* int64 closed_count */ 3:
                    message.closedCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppProgressCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 open_count = 2; */
        if (message.openCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.openCount);
        /* int64 closed_count = 3; */
        if (message.closedCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.closedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppProgressCount
 */
export const AppProgressCount = new AppProgressCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSelectionsStatusResponse$Type extends MessageType<AccessReviewSearchServiceSelectionsStatusResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse", [
            { no: 1, name: "total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "certified", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "rejected", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "cancelled", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deleted", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSelectionsStatusResponse>): AccessReviewSearchServiceSelectionsStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.total = 0;
        message.certified = 0;
        message.rejected = 0;
        message.skipped = 0;
        message.cancelled = 0;
        message.deleted = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSelectionsStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSelectionsStatusResponse): AccessReviewSearchServiceSelectionsStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total */ 1:
                    message.total = reader.int32();
                    break;
                case /* int32 certified */ 2:
                    message.certified = reader.int32();
                    break;
                case /* int32 rejected */ 3:
                    message.rejected = reader.int32();
                    break;
                case /* int32 skipped */ 4:
                    message.skipped = reader.int32();
                    break;
                case /* int32 cancelled */ 5:
                    message.cancelled = reader.int32();
                    break;
                case /* int32 deleted */ 6:
                    message.deleted = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSelectionsStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 total = 1; */
        if (message.total !== 0)
            writer.tag(1, WireType.Varint).int32(message.total);
        /* int32 certified = 2; */
        if (message.certified !== 0)
            writer.tag(2, WireType.Varint).int32(message.certified);
        /* int32 rejected = 3; */
        if (message.rejected !== 0)
            writer.tag(3, WireType.Varint).int32(message.rejected);
        /* int32 skipped = 4; */
        if (message.skipped !== 0)
            writer.tag(4, WireType.Varint).int32(message.skipped);
        /* int32 cancelled = 5; */
        if (message.cancelled !== 0)
            writer.tag(5, WireType.Varint).int32(message.cancelled);
        /* int32 deleted = 6; */
        if (message.deleted !== 0)
            writer.tag(6, WireType.Varint).int32(message.deleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse
 */
export const AccessReviewSearchServiceSelectionsStatusResponse = new AccessReviewSearchServiceSelectionsStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewRollup$Type extends MessageType<AccessReviewRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewRollup", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewRollup>): AccessReviewRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assignedTasks = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewRollup): AccessReviewRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReview access_review */ 1:
                    message.accessReview = AccessReview.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* int32 assigned_tasks */ 2:
                    message.assignedTasks = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReview access_review = 1; */
        if (message.accessReview)
            AccessReview.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 assigned_tasks = 2; */
        if (message.assignedTasks !== 0)
            writer.tag(2, WireType.Varint).int32(message.assignedTasks);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewRollup
 */
export const AccessReviewRollup = new AccessReviewRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceRollupRequest$Type extends MessageType<AccessReviewSearchServiceRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceRollupRequest>): AccessReviewSearchServiceRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.excludeCompleted = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceRollupRequest): AccessReviewSearchServiceRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* bool exclude_completed */ 4:
                    message.excludeCompleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* bool exclude_completed = 4; */
        if (message.excludeCompleted !== false)
            writer.tag(4, WireType.Varint).bool(message.excludeCompleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest
 */
export const AccessReviewSearchServiceRollupRequest = new AccessReviewSearchServiceRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceRollupResponse$Type extends MessageType<AccessReviewSearchServiceRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceRollupResponse>): AccessReviewSearchServiceRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceRollupResponse): AccessReviewSearchServiceRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewRollup list */ 1:
                    message.list.push(AccessReviewRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse
 */
export const AccessReviewSearchServiceRollupResponse = new AccessReviewSearchServiceRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsRequest$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask },
            { no: 10, name: "exclude_facets", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchEntitlementsRequest>): AccessReviewSearchServiceSearchEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        message.resourceTypeIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        message.excludeFacets = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchEntitlementsRequest): AccessReviewSearchServiceSearchEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 6:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string risk_level_ids */ 7:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 8:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask */ 9:
                    message.expandMask = AccessReviewAppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool exclude_facets */ 10:
                    message.excludeFacets = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string resource_type_ids = 6; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string risk_level_ids = 7; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 8; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 9; */
        if (message.expandMask)
            AccessReviewAppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool exclude_facets = 10; */
        if (message.excludeFacets !== false)
            writer.tag(10, WireType.Varint).bool(message.excludeFacets);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest
 */
export const AccessReviewSearchServiceSearchEntitlementsRequest = new AccessReviewSearchServiceSearchEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsResponse$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchEntitlementsResponse>): AccessReviewSearchServiceSearchEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchEntitlementsResponse): AccessReviewSearchServiceSearchEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list */ 1:
                    message.list.push(AccessReviewAppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                case /* c1.api.search.v1.Facets facets */ 4:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewAppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        /* c1.api.search.v1.Facets facets = 4; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse
 */
export const AccessReviewSearchServiceSearchEntitlementsResponse = new AccessReviewSearchServiceSearchEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsCountRequest$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsCountRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchEntitlementsCountRequest>): AccessReviewSearchServiceSearchEntitlementsCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        message.resourceTypeIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchEntitlementsCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchEntitlementsCountRequest): AccessReviewSearchServiceSearchEntitlementsCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 6:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string risk_level_ids */ 7:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 8:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchEntitlementsCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string resource_type_ids = 6; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string risk_level_ids = 7; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 8; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest
 */
export const AccessReviewSearchServiceSearchEntitlementsCountRequest = new AccessReviewSearchServiceSearchEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsCountResponse$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsCountResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchEntitlementsCountResponse>): AccessReviewSearchServiceSearchEntitlementsCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchEntitlementsCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchEntitlementsCountResponse): AccessReviewSearchServiceSearchEntitlementsCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchEntitlementsCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse
 */
export const AccessReviewSearchServiceSearchEntitlementsCountResponse = new AccessReviewSearchServiceSearchEntitlementsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppRollup$Type extends MessageType<AccessReviewAppRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppRollup", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppRollup>): AccessReviewAppRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assignedTasks = 0;
        message.completedTasksCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppRollup): AccessReviewAppRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int32 assigned_tasks */ 2:
                    message.assignedTasks = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 3:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 assigned_tasks = 2; */
        if (message.assignedTasks !== 0)
            writer.tag(2, WireType.Varint).int32(message.assignedTasks);
        /* int64 completed_tasks_count = 3; */
        if (message.completedTasksCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.completedTasksCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppRollup
 */
export const AccessReviewAppRollup = new AccessReviewAppRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupRef$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceEntitlementRollupRef>): AccessReviewSearchServiceEntitlementRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceEntitlementRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceEntitlementRollupRef): AccessReviewSearchServiceEntitlementRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceEntitlementRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef
 */
export const AccessReviewSearchServiceEntitlementRollupRef = new AccessReviewSearchServiceEntitlementRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupRequest$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementRollupExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceEntitlementRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceEntitlementRollupRequest>): AccessReviewSearchServiceEntitlementRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.userId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceEntitlementRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceEntitlementRollupRequest): AccessReviewSearchServiceEntitlementRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewEntitlementRollupExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs */ 6:
                    message.refs.push(AccessReviewSearchServiceEntitlementRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 7:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceEntitlementRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewEntitlementRollupExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewSearchServiceEntitlementRollupRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string query = 7; */
        if (message.query !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest
 */
export const AccessReviewSearchServiceEntitlementRollupRequest = new AccessReviewSearchServiceEntitlementRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupResponse$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollupByApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceEntitlementRollupResponse>): AccessReviewSearchServiceEntitlementRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceEntitlementRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceEntitlementRollupResponse): AccessReviewSearchServiceEntitlementRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp list */ 1:
                    message.list.push(AccessReviewEntitlementRollupByApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceEntitlementRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewEntitlementRollupByApp.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse
 */
export const AccessReviewSearchServiceEntitlementRollupResponse = new AccessReviewSearchServiceEntitlementRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupByAppRequest$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupByAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementRollupExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceEntitlementRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceEntitlementRollupByAppRequest>): AccessReviewSearchServiceEntitlementRollupByAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.userId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceEntitlementRollupByAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceEntitlementRollupByAppRequest): AccessReviewSearchServiceEntitlementRollupByAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewEntitlementRollupExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs */ 6:
                    message.refs.push(AccessReviewSearchServiceEntitlementRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 7:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 8:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceEntitlementRollupByAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewEntitlementRollupExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewSearchServiceEntitlementRollupRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string query = 7; */
        if (message.query !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 8; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest
 */
export const AccessReviewSearchServiceEntitlementRollupByAppRequest = new AccessReviewSearchServiceEntitlementRollupByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupByAppResponse$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupByAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceEntitlementRollupByAppResponse>): AccessReviewSearchServiceEntitlementRollupByAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceEntitlementRollupByAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceEntitlementRollupByAppResponse): AccessReviewSearchServiceEntitlementRollupByAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list */ 1:
                    message.list.push(AccessReviewEntitlementRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceEntitlementRollupByAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewEntitlementRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse
 */
export const AccessReviewSearchServiceEntitlementRollupByAppResponse = new AccessReviewSearchServiceEntitlementRollupByAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollup$Type extends MessageType<AccessReviewAppUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollup", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserRollup>): AccessReviewAppUserRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskCount = 0;
        message.completedTasksCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserRollup): AccessReviewAppUserRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* int32 task_count */ 2:
                    message.taskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 3:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 task_count = 2; */
        if (message.taskCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.taskCount);
        /* int64 completed_tasks_count = 3; */
        if (message.completedTasksCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.completedTasksCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollup
 */
export const AccessReviewAppUserRollup = new AccessReviewAppUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAccountsWithNoIdentityTaskCounts$Type extends MessageType<AccessReviewAccountsWithNoIdentityTaskCounts> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts", [
            { no: 1, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAccountsWithNoIdentityTaskCounts>): AccessReviewAccountsWithNoIdentityTaskCounts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openTaskCount = 0;
        message.completedTasksCount = 0;
        message.pendingActionsCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAccountsWithNoIdentityTaskCounts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAccountsWithNoIdentityTaskCounts): AccessReviewAccountsWithNoIdentityTaskCounts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 open_task_count */ 1:
                    message.openTaskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 2:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                case /* int64 pending_actions_count */ 3:
                    message.pendingActionsCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAccountsWithNoIdentityTaskCounts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 open_task_count = 1; */
        if (message.openTaskCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.openTaskCount);
        /* int64 completed_tasks_count = 2; */
        if (message.completedTasksCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.completedTasksCount);
        /* int64 pending_actions_count = 3; */
        if (message.pendingActionsCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.pendingActionsCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts
 */
export const AccessReviewAccountsWithNoIdentityTaskCounts = new AccessReviewAccountsWithNoIdentityTaskCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAccountsWithNoIdentityTaskStatus$Type extends MessageType<AccessReviewAccountsWithNoIdentityTaskStatus> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus", [
            { no: 1, name: "has_open_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "has_completed_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAccountsWithNoIdentityTaskStatus>): AccessReviewAccountsWithNoIdentityTaskStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasOpenTasks = false;
        message.hasCompletedTasks = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAccountsWithNoIdentityTaskStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAccountsWithNoIdentityTaskStatus): AccessReviewAccountsWithNoIdentityTaskStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_open_tasks */ 1:
                    message.hasOpenTasks = reader.bool();
                    break;
                case /* bool has_completed_tasks */ 2:
                    message.hasCompletedTasks = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAccountsWithNoIdentityTaskStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_open_tasks = 1; */
        if (message.hasOpenTasks !== false)
            writer.tag(1, WireType.Varint).bool(message.hasOpenTasks);
        /* bool has_completed_tasks = 2; */
        if (message.hasCompletedTasks !== false)
            writer.tag(2, WireType.Varint).bool(message.hasCompletedTasks);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus
 */
export const AccessReviewAccountsWithNoIdentityTaskStatus = new AccessReviewAccountsWithNoIdentityTaskStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewUserRollup$Type extends MessageType<AccessReviewUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewUserRollup", [
            { no: 1, name: "user", kind: "message", T: () => UserView },
            { no: 2, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 7, name: "pending_submission_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewUserRollup>): AccessReviewUserRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openTaskCount = 0;
        message.completedTasksCount = 0;
        message.expanded = [];
        message.id = "";
        message.pendingActionsCount = 0;
        message.pendingSubmissionCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewUserRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewUserRollup): AccessReviewUserRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserView user */ 1:
                    message.user = UserView.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* int32 open_task_count */ 2:
                    message.openTaskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 3:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                case /* repeated google.protobuf.Any expanded */ 4:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string id */ 5:
                    message.id = reader.string();
                    break;
                case /* int64 pending_actions_count */ 6:
                    message.pendingActionsCount = reader.int64().toNumber();
                    break;
                case /* int64 pending_submission_count */ 7:
                    message.pendingSubmissionCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewUserRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserView user = 1; */
        if (message.user)
            UserView.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 open_task_count = 2; */
        if (message.openTaskCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.openTaskCount);
        /* int64 completed_tasks_count = 3; */
        if (message.completedTasksCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.completedTasksCount);
        /* repeated google.protobuf.Any expanded = 4; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string id = 5; */
        if (message.id !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.id);
        /* int64 pending_actions_count = 6; */
        if (message.pendingActionsCount !== 0)
            writer.tag(6, WireType.Varint).int64(message.pendingActionsCount);
        /* int64 pending_submission_count = 7; */
        if (message.pendingSubmissionCount !== 0)
            writer.tag(7, WireType.Varint).int64(message.pendingSubmissionCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewUserRollup
 */
export const AccessReviewUserRollup = new AccessReviewUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupRef$Type extends MessageType<AccessReviewSearchServiceUserRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceUserRollupRef>): AccessReviewSearchServiceUserRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceUserRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceUserRollupRef): AccessReviewSearchServiceUserRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceUserRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef
 */
export const AccessReviewSearchServiceUserRollupRef = new AccessReviewSearchServiceUserRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupRequest$Type extends MessageType<AccessReviewSearchServiceUserRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceUserRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceUserRollupRequest>): AccessReviewSearchServiceUserRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceUserRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceUserRollupRequest): AccessReviewSearchServiceUserRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef refs */ 5:
                    message.refs.push(AccessReviewSearchServiceUserRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 6:
                    message.query = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 7:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceUserRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewSearchServiceUserRollupRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string query = 6; */
        if (message.query !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.query);
        /* c1.api.user.v1.UserExpandMask expand_mask = 7; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest
 */
export const AccessReviewSearchServiceUserRollupRequest = new AccessReviewSearchServiceUserRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupResponse$Type extends MessageType<AccessReviewSearchServiceUserRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewUserRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceUserRollupResponse>): AccessReviewSearchServiceUserRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceUserRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceUserRollupResponse): AccessReviewSearchServiceUserRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewUserRollup list */ 1:
                    message.list.push(AccessReviewUserRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceUserRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewUserRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewUserRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse
 */
export const AccessReviewSearchServiceUserRollupResponse = new AccessReviewSearchServiceUserRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsWithNoIdentityTaskCountsRequest$Type extends MessageType<AccountsWithNoIdentityTaskCountsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccountsWithNoIdentityTaskCountsRequest>): AccountsWithNoIdentityTaskCountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccountsWithNoIdentityTaskCountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountsWithNoIdentityTaskCountsRequest): AccountsWithNoIdentityTaskCountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountsWithNoIdentityTaskCountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest
 */
export const AccountsWithNoIdentityTaskCountsRequest = new AccountsWithNoIdentityTaskCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsWithNoIdentityTaskStatusRequest$Type extends MessageType<AccountsWithNoIdentityTaskStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccountsWithNoIdentityTaskStatusRequest>): AccountsWithNoIdentityTaskStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccountsWithNoIdentityTaskStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountsWithNoIdentityTaskStatusRequest): AccountsWithNoIdentityTaskStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountsWithNoIdentityTaskStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest
 */
export const AccountsWithNoIdentityTaskStatusRequest = new AccountsWithNoIdentityTaskStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupUserNavDataRequest$Type extends MessageType<AccessReviewSearchServiceUserRollupUserNavDataRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "current_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceUserRollupUserNavDataRequest>): AccessReviewSearchServiceUserRollupUserNavDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.currentUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceUserRollupUserNavDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceUserRollupUserNavDataRequest): AccessReviewSearchServiceUserRollupUserNavDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                case /* string current_user_id */ 3:
                    message.currentUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceUserRollupUserNavDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        /* string current_user_id = 3; */
        if (message.currentUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currentUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest
 */
export const AccessReviewSearchServiceUserRollupUserNavDataRequest = new AccessReviewSearchServiceUserRollupUserNavDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupUserNavDataResponse$Type extends MessageType<AccessReviewSearchServiceUserRollupUserNavDataResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse", [
            { no: 1, name: "previous_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 2, name: "current_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 3, name: "next_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceUserRollupUserNavDataResponse>): AccessReviewSearchServiceUserRollupUserNavDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceUserRollupUserNavDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceUserRollupUserNavDataResponse): AccessReviewSearchServiceUserRollupUserNavDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewUserRollup previous_user */ 1:
                    message.previousUser = AccessReviewUserRollup.internalBinaryRead(reader, reader.uint32(), options, message.previousUser);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewUserRollup current_user */ 2:
                    message.currentUser = AccessReviewUserRollup.internalBinaryRead(reader, reader.uint32(), options, message.currentUser);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewUserRollup next_user */ 3:
                    message.nextUser = AccessReviewUserRollup.internalBinaryRead(reader, reader.uint32(), options, message.nextUser);
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceUserRollupUserNavDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewUserRollup previous_user = 1; */
        if (message.previousUser)
            AccessReviewUserRollup.internalBinaryWrite(message.previousUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewUserRollup current_user = 2; */
        if (message.currentUser)
            AccessReviewUserRollup.internalBinaryWrite(message.currentUser, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewUserRollup next_user = 3; */
        if (message.nextUser)
            AccessReviewUserRollup.internalBinaryWrite(message.nextUser, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse
 */
export const AccessReviewSearchServiceUserRollupUserNavDataResponse = new AccessReviewSearchServiceUserRollupUserNavDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchAppUsersRequest$Type extends MessageType<AccessReviewSearchServiceSearchAppUsersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchAppUsersRequest>): AccessReviewSearchServiceSearchAppUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchAppUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchAppUsersRequest): AccessReviewSearchServiceSearchAppUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchAppUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest
 */
export const AccessReviewSearchServiceSearchAppUsersRequest = new AccessReviewSearchServiceSearchAppUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchAppUsersResponse$Type extends MessageType<AccessReviewSearchServiceSearchAppUsersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUser },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchAppUsersResponse>): AccessReviewSearchServiceSearchAppUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchAppUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchAppUsersResponse): AccessReviewSearchServiceSearchAppUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUser list */ 1:
                    message.list.push(AppUser.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchAppUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUser list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUser.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse
 */
export const AccessReviewSearchServiceSearchAppUsersResponse = new AccessReviewSearchServiceSearchAppUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppResourceRollupItem$Type extends MessageType<AccessReviewAppResourceRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppResourceRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResource },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppResourceRollupItem>): AccessReviewAppResourceRollupItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlements = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppResourceRollupItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppResourceRollupItem): AccessReviewAppResourceRollupItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResource item */ 1:
                    message.item = AppResource.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView entitlements */ 2:
                    message.entitlements.push(AccessReviewAppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppResourceRollupItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResource item = 1; */
        if (message.item)
            AppResource.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView entitlements = 2; */
        for (let i = 0; i < message.entitlements.length; i++)
            AccessReviewAppEntitlementView.internalBinaryWrite(message.entitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppResourceRollupItem
 */
export const AccessReviewAppResourceRollupItem = new AccessReviewAppResourceRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceRollupRef$Type extends MessageType<ResourceRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ResourceRollupRef>): ResourceRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceId = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<ResourceRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceRollupRef): ResourceRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_id */ 2:
                    message.appResourceId = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_id = 2; */
        if (message.appResourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceId);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceRollupRef
 */
export const ResourceRollupRef = new ResourceRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceRollupRequest$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchSelectedResourceRollupRequest>): AccessReviewSearchServiceSearchSelectedResourceRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchSelectedResourceRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchSelectedResourceRollupRequest): AccessReviewSearchServiceSearchSelectedResourceRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewAppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string query */ 6:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.ResourceRollupRef refs */ 7:
                    message.refs.push(ResourceRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchSelectedResourceRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewAppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string query = 6; */
        if (message.query !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.accessreview.v1.ResourceRollupRef refs = 7; */
        for (let i = 0; i < message.refs.length; i++)
            ResourceRollupRef.internalBinaryWrite(message.refs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest
 */
export const AccessReviewSearchServiceSearchSelectedResourceRollupRequest = new AccessReviewSearchServiceSearchSelectedResourceRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceRollupResponse$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppResourceRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchSelectedResourceRollupResponse>): AccessReviewSearchServiceSearchSelectedResourceRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchSelectedResourceRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchSelectedResourceRollupResponse): AccessReviewSearchServiceSearchSelectedResourceRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewAppResourceRollupItem list */ 1:
                    message.list.push(AccessReviewAppResourceRollupItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchSelectedResourceRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewAppResourceRollupItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewAppResourceRollupItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse
 */
export const AccessReviewSearchServiceSearchSelectedResourceRollupResponse = new AccessReviewSearchServiceSearchSelectedResourceRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppResourceTypeRollupItem$Type extends MessageType<AccessReviewAppResourceTypeRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeView },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppResourceTypeRollupItem>): AccessReviewAppResourceTypeRollupItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceCount = 0;
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppResourceTypeRollupItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppResourceTypeRollupItem): AccessReviewAppResourceTypeRollupItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResourceTypeView item */ 1:
                    message.item = AppResourceTypeView.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* int64 resource_count */ 2:
                    message.resourceCount = reader.int64().toNumber();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppResourceTypeRollupItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResourceTypeView item = 1; */
        if (message.item)
            AppResourceTypeView.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 resource_count = 2; */
        if (message.resourceCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.resourceCount);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem
 */
export const AccessReviewAppResourceTypeRollupItem = new AccessReviewAppResourceTypeRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeRollupRef$Type extends MessageType<ResourceTypeRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceTypeRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ResourceTypeRollupRef>): ResourceTypeRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceTypeId = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<ResourceTypeRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypeRollupRef): ResourceTypeRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_type_id */ 2:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypeRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_type_id = 2; */
        if (message.appResourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceTypeRollupRef
 */
export const ResourceTypeRollupRef = new ResourceTypeRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "200" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest>): AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest): AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.ResourceTypeRollupRef refs */ 5:
                    message.refs.push(ResourceTypeRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.accessreview.v1.ResourceTypeRollupRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            ResourceTypeRollupRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest
 */
export const AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest = new AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppResourceTypeRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse>): AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse): AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem list */ 1:
                    message.list.push(AccessReviewAppResourceTypeRollupItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewAppResourceTypeRollupItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse
 */
export const AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse = new AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchRef$Type extends MessageType<AccessReviewAppUserDetailRowSearchRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRowSearchRef>): AccessReviewAppUserDetailRowSearchRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRowSearchRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRowSearchRef): AccessReviewAppUserDetailRowSearchRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRowSearchRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef
 */
export const AccessReviewAppUserDetailRowSearchRef = new AccessReviewAppUserDetailRowSearchRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewUserNavRollupRef$Type extends MessageType<AccessReviewUserNavRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewUserNavRollupRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewUserNavRollupRef>): AccessReviewUserNavRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewUserNavRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewUserNavRollupRef): AccessReviewUserNavRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewUserNavRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewUserNavRollupRef
 */
export const AccessReviewUserNavRollupRef = new AccessReviewUserNavRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppNavRollupRef$Type extends MessageType<AccessReviewAppNavRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppNavRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppNavRollupRef>): AccessReviewAppNavRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppNavRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppNavRollupRef): AccessReviewAppNavRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppNavRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppNavRollupRef
 */
export const AccessReviewAppNavRollupRef = new AccessReviewAppNavRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchRequest$Type extends MessageType<AccessReviewAppUserDetailRowSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AccessReviewAppUserDetailRowExpandMask },
            { no: 7, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowSearchRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 9, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRowSearchRequest>): AccessReviewAppUserDetailRowSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.identityUserId = "";
        message.reviewerUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.appUserIds = [];
        message.refs = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRowSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRowSearchRequest): AccessReviewAppUserDetailRowSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string identity_user_id */ 2:
                    message.identityUserId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask */ 6:
                    message.expandMask = AccessReviewAppUserDetailRowExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string app_user_ids */ 7:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs */ 8:
                    message.refs.push(AccessReviewAppUserDetailRowSearchRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string app_ids */ 9:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRowSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string identity_user_id = 2; */
        if (message.identityUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 6; */
        if (message.expandMask)
            AccessReviewAppUserDetailRowExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_user_ids = 7; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 8; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewAppUserDetailRowSearchRef.internalBinaryWrite(message.refs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 9; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest
 */
export const AccessReviewAppUserDetailRowSearchRequest = new AccessReviewAppUserDetailRowSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchResponse$Type extends MessageType<AccessReviewAppUserDetailRowSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRow },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRowSearchResponse>): AccessReviewAppUserDetailRowSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRowSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRowSearchResponse): AccessReviewAppUserDetailRowSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRow list */ 1:
                    message.list.push(AccessReviewAppUserDetailRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRowSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRow list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewAppUserDetailRow.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse
 */
export const AccessReviewAppUserDetailRowSearchResponse = new AccessReviewAppUserDetailRowSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollupNavDataRequest$Type extends MessageType<AccessReviewAppUserRollupNavDataRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewAppUserDetailRowExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserRollupNavDataRequest>): AccessReviewAppUserRollupNavDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.identityUserId = "";
        message.reviewerUserId = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserRollupNavDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserRollupNavDataRequest): AccessReviewAppUserRollupNavDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string identity_user_id */ 2:
                    message.identityUserId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewAppUserDetailRowExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserRollupNavDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string identity_user_id = 2; */
        if (message.identityUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewAppUserDetailRowExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest
 */
export const AccessReviewAppUserRollupNavDataRequest = new AccessReviewAppUserRollupNavDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollupNavDataResponse$Type extends MessageType<AccessReviewAppUserRollupNavDataResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse", [
            { no: 1, name: "previous_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "current_user", kind: "message", T: () => AppUserView },
            { no: 3, name: "next_user", kind: "message", T: () => AppUserView }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserRollupNavDataResponse>): AccessReviewAppUserRollupNavDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserRollupNavDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserRollupNavDataResponse): AccessReviewAppUserRollupNavDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView previous_user */ 1:
                    message.previousUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.previousUser);
                    break;
                case /* c1.api.app.v1.AppUserView current_user */ 2:
                    message.currentUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.currentUser);
                    break;
                case /* c1.api.app.v1.AppUserView next_user */ 3:
                    message.nextUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.nextUser);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserRollupNavDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView previous_user = 1; */
        if (message.previousUser)
            AppUserView.internalBinaryWrite(message.previousUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserView current_user = 2; */
        if (message.currentUser)
            AppUserView.internalBinaryWrite(message.currentUser, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserView next_user = 3; */
        if (message.nextUser)
            AppUserView.internalBinaryWrite(message.nextUser, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse
 */
export const AccessReviewAppUserRollupNavDataResponse = new AccessReviewAppUserRollupNavDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavFirstOpenSelectionRequest$Type extends MessageType<AccessReviewSearchServiceNavFirstOpenSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceNavFirstOpenSelectionRequest>): AccessReviewSearchServiceNavFirstOpenSelectionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceNavFirstOpenSelectionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceNavFirstOpenSelectionRequest): AccessReviewSearchServiceNavFirstOpenSelectionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.NextOpenSelectionType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceNavFirstOpenSelectionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        /* c1.api.accessreview.v1.NextOpenSelectionType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest
 */
export const AccessReviewSearchServiceNavFirstOpenSelectionRequest = new AccessReviewSearchServiceNavFirstOpenSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavFirstOpenSelectionResponse$Type extends MessageType<AccessReviewSearchServiceNavFirstOpenSelectionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceNavFirstOpenSelectionResponse>): AccessReviewSearchServiceNavFirstOpenSelectionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceNavFirstOpenSelectionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceNavFirstOpenSelectionResponse): AccessReviewSearchServiceNavFirstOpenSelectionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.accessreview.v1.NextOpenSelectionType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceNavFirstOpenSelectionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.accessreview.v1.NextOpenSelectionType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse
 */
export const AccessReviewSearchServiceNavFirstOpenSelectionResponse = new AccessReviewSearchServiceNavFirstOpenSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavNextSelectionRequest$Type extends MessageType<AccessReviewSearchServiceNavNextSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "current_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceNavNextSelectionRequest>): AccessReviewSearchServiceNavNextSelectionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.currentId = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceNavNextSelectionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceNavNextSelectionRequest): AccessReviewSearchServiceNavNextSelectionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                case /* string current_id */ 5:
                    message.currentId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.NextOpenSelectionType type */ 4:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceNavNextSelectionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        /* c1.api.accessreview.v1.NextOpenSelectionType type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        /* string current_id = 5; */
        if (message.currentId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.currentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest
 */
export const AccessReviewSearchServiceNavNextSelectionRequest = new AccessReviewSearchServiceNavNextSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavNextSelectionResponse$Type extends MessageType<AccessReviewSearchServiceNavNextSelectionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSearchServiceNavNextSelectionResponse>): AccessReviewSearchServiceNavNextSelectionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSearchServiceNavNextSelectionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSearchServiceNavNextSelectionResponse): AccessReviewSearchServiceNavNextSelectionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.accessreview.v1.NextOpenSelectionType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSearchServiceNavNextSelectionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.accessreview.v1.NextOpenSelectionType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse
 */
export const AccessReviewSearchServiceNavNextSelectionResponse = new AccessReviewSearchServiceNavNextSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowExpandMask$Type extends MessageType<AccessReviewAppUserDetailRowExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "last_usage", "resource_type_ids", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRowExpandMask>): AccessReviewAppUserDetailRowExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRowExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRowExpandMask): AccessReviewAppUserDetailRowExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRowExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask
 */
export const AccessReviewAppUserDetailRowExpandMask = new AccessReviewAppUserDetailRowExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowTaskDetails$Type extends MessageType<AccessReviewAppUserDetailRowTaskDetails> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRowTaskDetails>): AccessReviewAppUserDetailRowTaskDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRowTaskDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRowTaskDetails): AccessReviewAppUserDetailRowTaskDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.task.v1.TaskView task */ 2:
                    message.task = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRowTaskDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskView task = 2; */
        if (message.task)
            TaskView.internalBinaryWrite(message.task, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails
 */
export const AccessReviewAppUserDetailRowTaskDetails = new AccessReviewAppUserDetailRowTaskDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRow$Type extends MessageType<AccessReviewAppUserDetailRow> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRow", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowTaskDetails },
            { no: 3, name: "AllTicketsCompleted", kind: "scalar", jsonName: "AllTicketsCompleted", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 7, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppUserDetailRow>): AccessReviewAppUserDetailRow {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlements = [];
        message.allTicketsCompleted = false;
        message.appId = "";
        message.appUserId = "";
        message.pendingActionsCount = 0;
        message.openTaskCount = 0;
        message.completedTasksCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppUserDetailRow>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppUserDetailRow): AccessReviewAppUserDetailRow {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView app_user */ 1:
                    message.appUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails entitlements */ 2:
                    message.entitlements.push(AccessReviewAppUserDetailRowTaskDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool AllTicketsCompleted */ 3:
                    message.allTicketsCompleted = reader.bool();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 5:
                    message.appUserId = reader.string();
                    break;
                case /* int64 pending_actions_count */ 6:
                    message.pendingActionsCount = reader.int64().toNumber();
                    break;
                case /* int32 open_task_count */ 7:
                    message.openTaskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 8:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppUserDetailRow, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView app_user = 1; */
        if (message.appUser)
            AppUserView.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails entitlements = 2; */
        for (let i = 0; i < message.entitlements.length; i++)
            AccessReviewAppUserDetailRowTaskDetails.internalBinaryWrite(message.entitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool AllTicketsCompleted = 3; */
        if (message.allTicketsCompleted !== false)
            writer.tag(3, WireType.Varint).bool(message.allTicketsCompleted);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 5; */
        if (message.appUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserId);
        /* int64 pending_actions_count = 6; */
        if (message.pendingActionsCount !== 0)
            writer.tag(6, WireType.Varint).int64(message.pendingActionsCount);
        /* int32 open_task_count = 7; */
        if (message.openTaskCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.openTaskCount);
        /* int64 completed_tasks_count = 8; */
        if (message.completedTasksCount !== 0)
            writer.tag(8, WireType.Varint).int64(message.completedTasksCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRow
 */
export const AccessReviewAppUserDetailRow = new AccessReviewAppUserDetailRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserRollup$Type extends MessageType<AppUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AppUserRollup", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 3, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "pending_submission_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserRollup>): AppUserRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openTaskCount = 0;
        message.completedTasksCount = 0;
        message.pendingSubmissionCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppUserRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserRollup): AppUserRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView app_user */ 1:
                    message.appUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* int32 open_task_count */ 3:
                    message.openTaskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 4:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                case /* int32 pending_submission_count */ 5:
                    message.pendingSubmissionCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView app_user = 1; */
        if (message.appUser)
            AppUserView.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 open_task_count = 3; */
        if (message.openTaskCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.openTaskCount);
        /* int64 completed_tasks_count = 4; */
        if (message.completedTasksCount !== 0)
            writer.tag(4, WireType.Varint).int64(message.completedTasksCount);
        /* int32 pending_submission_count = 5; */
        if (message.pendingSubmissionCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.pendingSubmissionCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppUserRollup
 */
export const AppUserRollup = new AppUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserRollupRequest$Type extends MessageType<SearchAppUserRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppUserRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowSearchRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserRollupRequest>): SearchAppUserRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.identityUserId = "";
        message.reviewerUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserRollupRequest): SearchAppUserRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string identity_user_id */ 2:
                    message.identityUserId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 6:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs */ 7:
                    message.refs.push(AccessReviewAppUserDetailRowSearchRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string identity_user_id = 2; */
        if (message.identityUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 7; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewAppUserDetailRowSearchRef.internalBinaryWrite(message.refs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppUserRollupRequest
 */
export const SearchAppUserRollupRequest = new SearchAppUserRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserRollupResponse$Type extends MessageType<SearchAppUserRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppUserRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserRollupResponse>): SearchAppUserRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserRollupResponse): SearchAppUserRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppUserRollup list */ 1:
                    message.list.push(AppUserRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppUserRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppUserRollupResponse
 */
export const SearchAppUserRollupResponse = new SearchAppUserRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppRollup$Type extends MessageType<AppRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AppRollup", [
            { no: 1, name: "app", kind: "message", T: () => AppView },
            { no: 2, name: "task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "pending_submission_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AppRollup>): AppRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskCount = 0;
        message.openTaskCount = 0;
        message.completedTasksCount = 0;
        message.pendingSubmissionCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppRollup): AppRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppView app */ 1:
                    message.app = AppView.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int32 task_count */ 2:
                    message.taskCount = reader.int32();
                    break;
                case /* int32 open_task_count */ 3:
                    message.openTaskCount = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 4:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                case /* int32 pending_submission_count */ 5:
                    message.pendingSubmissionCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppView app = 1; */
        if (message.app)
            AppView.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 task_count = 2; */
        if (message.taskCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.taskCount);
        /* int32 open_task_count = 3; */
        if (message.openTaskCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.openTaskCount);
        /* int64 completed_tasks_count = 4; */
        if (message.completedTasksCount !== 0)
            writer.tag(4, WireType.Varint).int64(message.completedTasksCount);
        /* int32 pending_submission_count = 5; */
        if (message.pendingSubmissionCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.pendingSubmissionCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppRollup
 */
export const AppRollup = new AppRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppRollupRequest$Type extends MessageType<SearchAppRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppNavRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppRollupRequest>): SearchAppRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppRollupRequest): SearchAppRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppExpandMask expand_mask */ 5:
                    message.expandMask = AppExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewAppNavRollupRef refs */ 6:
                    message.refs.push(AccessReviewAppNavRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 7:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewAppNavRollupRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewAppNavRollupRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string query = 7; */
        if (message.query !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppRollupRequest
 */
export const SearchAppRollupRequest = new SearchAppRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppRollupResponse$Type extends MessageType<SearchAppRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAppRollupResponse>): SearchAppRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppRollupResponse): SearchAppRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppRollup list */ 1:
                    message.list.push(AppRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppRollupResponse
 */
export const SearchAppRollupResponse = new SearchAppRollupResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSearchService
 */
export const AccessReviewSearchService = new ServiceType("c1.api.accessreview.v1.AccessReviewSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchRequest, O: AccessReviewSearchServiceSearchResponse },
    { name: "SelectionsStatus", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSelectionsStatusRequest, O: AccessReviewSearchServiceSelectionsStatusResponse },
    { name: "CountOpenReviewsByUser", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountOpenReviewsByUserRequest, O: AccessReviewSearchServiceCountOpenReviewsByUserResponse },
    { name: "GetProgressByApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceGetProgressByAppRequest, O: AccessReviewSearchServiceGetProgressByAppResponse },
    { name: "CountCompleteReviewers", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountCompleteReviewersRequest, O: AccessReviewSearchServiceCountCompleteReviewersResponse },
    { name: "CountIncompleteReviewers", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountIncompleteReviewersRequest, O: AccessReviewSearchServiceCountIncompleteReviewersResponse },
    { name: "GetReviewerDecisions", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceGetReviewerDecisionsRequest, O: AccessReviewSearchServiceGetReviewerDecisionsResponse },
    { name: "Rollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceRollupRequest, O: AccessReviewSearchServiceRollupResponse },
    { name: "EntitlementRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceEntitlementRollupRequest, O: AccessReviewSearchServiceEntitlementRollupResponse },
    { name: "EntitlementRollupByApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceEntitlementRollupByAppRequest, O: AccessReviewSearchServiceEntitlementRollupByAppResponse },
    { name: "UserRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceUserRollupRequest, O: AccessReviewSearchServiceUserRollupResponse },
    { name: "AccountsWithNoIdentityTaskCount", options: { "authz.method": { role: "VIEWER" } }, I: AccountsWithNoIdentityTaskCountsRequest, O: AccessReviewAccountsWithNoIdentityTaskCounts },
    { name: "AccountsWithNoIdentityTaskStatus", options: { "authz.method": { role: "VIEWER" } }, I: AccountsWithNoIdentityTaskStatusRequest, O: AccessReviewAccountsWithNoIdentityTaskStatus },
    { name: "UserRollupNavData", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceUserRollupUserNavDataRequest, O: AccessReviewSearchServiceUserRollupUserNavDataResponse },
    { name: "SearchEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchEntitlementsRequest, O: AccessReviewSearchServiceSearchEntitlementsResponse },
    { name: "SearchEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchEntitlementsCountRequest, O: AccessReviewSearchServiceSearchEntitlementsCountResponse },
    { name: "SearchSelectedResourceRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchSelectedResourceRollupRequest, O: AccessReviewSearchServiceSearchSelectedResourceRollupResponse },
    { name: "SearchSelectedResourceTypeRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, O: AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse },
    { name: "AppUserDetailRowRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewAppUserDetailRowSearchRequest, O: AccessReviewAppUserDetailRowSearchResponse },
    { name: "AppUserDetailRowRollupNavData", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewAppUserRollupNavDataRequest, O: AccessReviewAppUserRollupNavDataResponse },
    { name: "NavFirstOpenSelection", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceNavFirstOpenSelectionRequest, O: AccessReviewSearchServiceNavFirstOpenSelectionResponse },
    { name: "NavNextSelection", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceNavNextSelectionRequest, O: AccessReviewSearchServiceNavNextSelectionResponse },
    { name: "SearchAppUserRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserRollupRequest, O: SearchAppUserRollupResponse },
    { name: "SearchAppRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppRollupRequest, O: SearchAppRollupResponse }
]);
